import React, { useContext, useEffect, useCallback, useState, useMemo} from 'react';
import { useSearchParams, useLocation, useNavigate, useParams} from 'react-router-dom';

import AppContext from './AppContext'
import RouteContext from './RouteContext'
import SearchParamContext from './SearchParamContext'

import * as FirestoreService from '../services/firestore';
import {urlWithoutParams} from '../utils/utils'

const InstanciaParam = ({children}) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { mock, user, resetState, instancia, setInstancia, instanciaInfo, setInstanciaInfo, setLoading } = useContext(AppContext);     

    const { searchParams } = useContext(SearchParamContext); 

    const { urlInstancia } = useParams();

    const urlMain = useMemo(
      ()=> urlWithoutParams(location.pathname,urlInstancia)
    ,[location,urlInstancia])    

    useEffect(()=>{                                         
      if(!instancia || (urlInstancia && urlInstancia!=instancia)){        
        //se instancia da url é diferente da instancia armazenada, carrega instancia
        carregaInstancia(urlInstancia)
      }
    },[])

    useEffect(()=>{
      //atualiza a url com base na instancia carregada      
      if(instancia){
        if(!(!instancia || (urlInstancia && urlInstancia!=instancia))){      
          nav(instancia)           
        }
      }      
    },[instancia,urlMain])

    useEffect(()=>{          
      if(instanciaInfo?.onLine==false){
        //Se instancia está offline, tenta carregar a instancia default  
        carregaInstancia(urlInstancia)        
      }
    },[instanciaInfo])

    //carrega a istancia do firestore
    const carregaInstancia = (urlInstancia)=>{
      
      //Limpa dados ao carregar nova instancia
      resetState();      
      setLoading(true)
      FirestoreService.carregaInstancia(mock,urlInstancia,user).then( instancia =>{          
        setInstancia(instancia);
        nav(instancia)
      }).catch(error =>{
        alert("Não foi possível carregar a instância desejada")
        setLoading(false)
        navigate("/Error500")
      })   
    }

    const nav =(instancia)=>{
      
      let path = urlMain +"/"+instancia
      setTimeout(()=>
        navigate({
          pathname: path,        
          replace: true, 
          search: searchParams.toLocaleString()
        })
      ,0)
    }
    

    return <div className={"flex flex-column flex-grow-1"}>{children}</div>
}

export default InstanciaParam;
